import { render, staticRenderFns } from "./Platform403Error.vue?vue&type=template&id=7ff2aa56&"
import script from "./Platform403Error.vue?vue&type=script&lang=js&"
export * from "./Platform403Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports